<div class="simulador-tela">
<div class="simulador">
  <header class="simulador__cabecalho">
    <div class="simulador__identidade">
      <div class="simulador__avatar"><i class="fas fa-headset" aria-hidden="true"></i></div>
      <div>
        <h4>Testar MIA Gestor</h4>
        <small>Converse como o lojista conversaria no WhatsApp. É o ensaio do canal real.</small>
      </div>
    </div>

    <div class="simulador__acoes">
      <span class="simulador__selo" *ngIf="conversa.onboardingId"
            [class.simulador__selo--real]="!naoExecutarAcoes">
        implantação #{{ conversa.onboardingId }} · real
      </span>
      <span class="simulador__selo" *ngIf="conversa.empresaId">empresa #{{ conversa.empresaId }}</span>
      <button class="simulador__toggle" [class.simulador__toggle--ativo]="naoExecutarAcoes"
              (click)="naoExecutarAcoes = !naoExecutarAcoes"
              title="Com a trava ligada a proposta aparece e a folha abre, mas o confirmar não executa — dá para ajustar texto sem criar empresa">
        <i class="fas" [class.fa-lock]="naoExecutarAcoes" [class.fa-lock-open]="!naoExecutarAcoes"
           aria-hidden="true"></i>
        {{ naoExecutarAcoes ? 'Não executar ações' : 'Ações executam de verdade' }}
      </button>
      <button class="simulador__nova" (click)="recarregue()" [disabled]="conversa.enviando"
              title="Recarrega o estado persistido desta implantação">
        <i class="fas fa-sync-alt" aria-hidden="true"></i> Recarregar
      </button>
      <button class="simulador__toggle" type="button" (click)="gereConviteWhatsapp()"
              [disabled]="gerandoConvite" title="Gera o link wa.me que amarra o número do lojista a este usuário (vale 24h, uma vez)">
        <i class="fab fa-whatsapp" aria-hidden="true"></i>
        {{ gerandoConvite ? 'Gerando convite…' : 'Convite WhatsApp' }}
      </button>
      <button class="simulador__nova" *ngIf="!confirmandoReinicio"
              [disabled]="!conversa.onboardingId || conversa.reiniciando"
              title="Encerra esta implantação e abre outra do zero — empresa e produtos já criados continuam existindo"
              (click)="confirmandoReinicio = true">
        <i class="fas fa-redo-alt" aria-hidden="true"></i> Começar do zero
      </button>
      <span class="simulador__confirma" *ngIf="confirmandoReinicio">
        Encerra esta implantação.
        <button (click)="confirmandoReinicio = false">Voltar</button>
        <button class="simulador__confirma--sim" [disabled]="conversa.reiniciando" (click)="reinicie()">
          {{ conversa.reiniciando ? 'Começando…' : 'Confirmar' }}
        </button>
      </span>
      <a class="simulador__nova" routerLink="/admin/mia-gestor">
        <i class="fas fa-external-link-alt" aria-hidden="true"></i> Abrir painel
      </a>
    </div>
  </header>

  <!-- convite do canal real: o lojista abre o link, a primeira mensagem carrega o token -->
  <div class="simulador__convite" *ngIf="convite || erroConvite">
    <ng-container *ngIf="convite">
      <span *ngIf="!convite.canalAtivo" class="simulador__convite-aviso">
        Canal WhatsApp desligado: nenhum número é a Mia Gestor. Escolha um em <a routerLink="/admin/mia-gestor/numeros">Número da Mia</a>.
      </span>
      <span *ngIf="convite.link">
        Link do convite (vale 24h, uma vez):
        <a [href]="convite.link" target="_blank" rel="noopener noreferrer">{{ convite.link }}</a>
      </span>
      <span *ngIf="!convite.link">
        Número do Gestor não configurado (GESTOR_IA_WHATSAPP_NUMERO). Primeira mensagem do lojista: <b>{{ convite.mensagemInicial }}</b>
      </span>
    </ng-container>
    <span *ngIf="erroConvite" class="simulador__convite-aviso">{{ erroConvite }}</span>
  </div>

  <div class="simulador__aviso" *ngIf="!naoExecutarAcoes">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <div>
      <strong>A trava está desligada.</strong>
      O que for aprovado aqui usa a mesma rota, o mesmo hash e a mesma auditoria do painel —
      cria empresa e importa produto de verdade.
    </div>
  </div>

  <div class="simulador__aviso simulador__aviso--erro" *ngIf="conversa.erro">
    <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
    <div>{{ conversa.erro }}</div>
  </div>

  <!-- corpo do chat -->
  <div class="simulador__corpo" #corpoChat>
    <div class="simulador__boasvindas" *ngIf="!conversa.mensagens.length && !conversa.carregando">
      <div class="simulador__boasvindas-icone"><i class="fas fa-comment-dots" aria-hidden="true"></i></div>
      <h5>Comece a conversa</h5>
      <p>Escreva como um lojista escreveria,<br>ou use uma das sugestões:</p>
      <div class="simulador__sugestoes">
        <button *ngFor="let sugestao of sugestoes" (click)="envieSugestao(sugestao)">{{ sugestao }}</button>
      </div>
    </div>

    <ng-container *ngFor="let item of conversa.mensagens">
      <div class="simulador-bolha-wrapper simulador-bolha-wrapper--centro" *ngIf="item.papel === 'nota'">
        <div class="simulador-nota"><span>{{ item.texto }}</span></div>
      </div>

      <div class="simulador-bolha-wrapper" *ngIf="item.papel !== 'nota'"
           [class.simulador-bolha-wrapper--direita]="item.papel === 'usuario'">
        <div class="simulador-bolha"
             [class.simulador-bolha--lojista]="item.papel === 'usuario'"
             [class.simulador-bolha--mia]="item.papel === 'gestor'"
             [class.simulador-bolha--foto]="!!item.documento?.imagens?.length">

          <!-- foto do cardápio: preview como no WhatsApp (até 4 na grade, o resto vira +N) -->
          <div class="simulador-fotos" *ngIf="item.documento?.imagens as fotos"
               [class.simulador-fotos--grade]="fotos.length > 1">
            <a class="simulador-fotos__item" *ngFor="let url of fotos | slice:0:4; let i = index"
               [href]="url" target="_blank" rel="noopener noreferrer" title="Abrir a foto">
              <img [src]="url" alt="">
              <span class="simulador-fotos__mais" *ngIf="i === 3 && fotos.length > 4">
                +{{ fotos.length - 4 }}
              </span>
            </a>
            <small class="simulador-fotos__legenda">
              {{ item.texto }} · {{ conversa.tamanhoLegivel(item.documento.tamanhoBytes) }}
            </small>
          </div>

          <!-- PDF: cartão de documento, como no WhatsApp -->
          <div class="simulador-documento" *ngIf="item.documento && !item.documento.imagens?.length">
            <i class="fas fa-file-pdf" aria-hidden="true"></i>
            <span>
              <b>{{ item.texto }}</b>
              <small>{{ conversa.tamanhoLegivel(item.documento.tamanhoBytes) }}</small>
            </span>
          </div>

          <div class="simulador-bolha__texto" *ngIf="!item.documento">
            <ng-container *ngFor="let trecho of partesDaMensagem(item.texto)">
              <a class="simulador-bolha__link" *ngIf="trecho.link" [href]="trecho.link"
                 target="_blank" rel="noopener noreferrer">{{ trecho.texto }}</a>
              <strong *ngIf="trecho.destaque && !trecho.link">{{ trecho.texto }}</strong>
              <ng-container *ngIf="!trecho.destaque && !trecho.link">{{ trecho.texto }}</ng-container>
            </ng-container>
          </div>

          <div class="simulador-ferramentas" *ngIf="item.ferramentas?.length">
            <span class="simulador-ferramentas__chip" *ngFor="let ferramenta of item.ferramentas"
                  [class.simulador-ferramentas__chip--erro]="!ferramenta.sucesso"
                  [title]="ferramenta.nome + ' · ' + ferramenta.duracaoMs + 'ms'">
              <i class="fas" [class.fa-wrench]="ferramenta.sucesso"
                 [class.fa-exclamation-triangle]="!ferramenta.sucesso" aria-hidden="true"></i>
              {{ conversa.rotuloDaFerramenta(ferramenta.nome) }}
            </span>
          </div>

          <div class="simulador-bolha__meta">{{ item.horario | date:'HH:mm' }}</div>

          <ng-container *ngFor="let botao of item.interativo?.botoes">
            <!-- cta_url: abre o endereço, como o botão de link do WhatsApp -->
            <a class="simulador-botao simulador-botao--link" *ngIf="botao.acao === 'abrir'"
               [class.simulador-botao--cortado]="rotuloFoiCortado(botao.rotulo)"
               [href]="botao.href" target="_blank" rel="noopener noreferrer">
              <i class="fas fa-external-link-alt" aria-hidden="true"></i>
              {{ rotuloDeBotao(botao.rotulo) }}
            </a>
            <!-- reply button: tocar envia o rótulo como mensagem -->
            <button class="simulador-botao" *ngIf="botao.acao !== 'abrir'"
                    [class.simulador-botao--cortado]="rotuloFoiCortado(botao.rotulo)"
                    [disabled]="conversa.enviando"
                    (click)="envieSugestao(botao.rotulo)">
              {{ rotuloDeBotao(botao.rotulo) }}
            </button>
          </ng-container>
          <details *ngIf="item.interativo?.tipo === 'lista'" #listaOpcoes>
            <summary class="simulador-botao">{{ item.interativo.rotulo }}</summary>
            <button class="simulador-botao" *ngFor="let opcao of item.interativo.itens"
                    [disabled]="conversa.enviando"
                    (click)="listaOpcoes.open = false; envieSugestao(opcao.titulo)">
              {{ opcao.titulo }}<span *ngIf="opcao.descricao"> — {{ opcao.descricao }}</span>
            </button>
          </details>
        </div>
      </div>
    </ng-container>

    <!-- análise em andamento: contagem real vinda do extrator, atualizada a cada poll -->
    <div class="simulador-bolha-wrapper" *ngIf="conversa.analisando">
      <div class="simulador-bolha simulador-bolha--mia">
        <div class="simulador-bolha__texto">Lendo seu cardápio… 🔎<ng-container *ngIf="conversa.progressoAnalise"> Já achei <strong>{{ conversa.progressoAnalise.produtos }} produto(s)</strong> em <strong>{{ conversa.progressoAnalise.categorias }} categoria(s)</strong>!</ng-container></div>
      </div>
    </div>

    <!-- rascunho: cartão compacto + botão que abre folha (o chat não imprime tabela) -->
    <div class="simulador-bolha-wrapper" *ngIf="conversa.podeRevisarCardapio">
      <div class="simulador-bolha simulador-bolha--mia">
        <div class="simulador-bolha__texto">
          Pronto! Encontrei {{ conversa.totalProdutosRascunho }} itens em
          {{ conversa.analiseCardapio.estatisticas?.categorias }} categorias.
          <span *ngIf="conversa.bloqueiosRascunho">
            {{ conversa.itensProntosRascunho }} já estão prontos e
            {{ conversa.bloqueiosRascunho }} pedem uma conferência rápida.
          </span>
        </div>
        <div class="simulador-mini">
          <b>RASCUNHO v{{ conversa.analiseCardapio.versao }}</b>
          <span>{{ conversa.itensProntosRascunho }} prontos</span>
          <span *ngIf="conversa.bloqueiosRascunho">{{ conversa.bloqueiosRascunho }} para conferir</span>
        </div>
        <div class="simulador-bolha__meta">agora</div>
        <button class="simulador-botao" (click)="prepareImportacao()"
                [disabled]="conversa.operandoCardapio || !conversa.referenciasSelecionadas.length"
                [class.simulador-botao--cortado]="rotuloFoiCortado('Importar cardápio')">
          {{ rotuloDeBotao(conversa.operandoCardapio ? 'Preparando…' : 'Importar cardápio') }}
        </button>
        <button class="simulador-botao" (click)="abraRascunho()"
                [disabled]="conversa.operandoCardapio"
                [class.simulador-botao--cortado]="rotuloFoiCortado('Revisar antes')">
          {{ rotuloDeBotao('Revisar antes') }}
        </button>
      </div>
    </div>

    <!-- aprovação: o botão da bolha só abre a folha; confirmar mora lá dentro -->
    <div class="simulador-bolha-wrapper" *ngIf="conversa.acaoPendente">
      <div class="simulador-bolha simulador-bolha--mia">
        <div class="simulador-bolha__texto">{{ conversa.acaoPendente.impacto }}</div>
        <div class="simulador-bolha__meta">agora</div>
        <button class="simulador-botao" (click)="abraAprovacao()"
                [class.simulador-botao--cortado]="rotuloFoiCortado(conversa.rotuloDaAprovacao)"
                [title]="rotuloFoiCortado(conversa.rotuloDaAprovacao)
                  ? 'A Cloud API corta o rótulo em 20 caracteres — é assim que o lojista vê'
                  : conversa.rotuloDaAprovacao">
          {{ rotuloDeBotao(conversa.rotuloDaAprovacao) }}
        </button>
        <button class="simulador-botao" (click)="cancele()" [disabled]="conversa.operandoAcao">
          {{ rotuloDeBotao('Corrigir algo') }}
        </button>
      </div>
    </div>

    <div class="simulador-bolha-wrapper" *ngIf="conversa.enviando || conversa.operandoCardapio">
      <div class="simulador-bolha simulador-bolha--mia simulador-digitando">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>

  <!-- folha de aprovação -->
  <div class="simulador-folha" *ngIf="folhaAprovacao && conversa.acaoPendente">
    <div class="simulador-folha__fundo" (click)="folhaAprovacao = false"></div>
    <div class="simulador-folha__painel">
      <header>
        <span>O que será feito</span>
        <button (click)="folhaAprovacao = false" title="Fechar">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="simulador-folha__corpo">
        <strong>{{ conversa.tituloDaAcao }}</strong>
        <p>{{ conversa.acaoPendente.impacto }}</p>

        <dl *ngIf="conversa.previewEmpresa as empresa">
          <div><dt>Empresa</dt><dd>{{ empresa.nome }}</dd></div>
          <div><dt>Endereço</dt><dd>{{ empresa.subdominio }}</dd></div>
          <div><dt>Responsável</dt><dd>{{ empresa.responsavel?.nome }}</dd></div>
          <div *ngIf="empresa.whatsapp"><dt>WhatsApp</dt><dd>{{ empresa.whatsapp }}</dd></div>
          <div *ngIf="empresa.endereco"><dt>Local</dt><dd>{{ empresa.endereco }}</dd></div>
        </dl>

        <p class="simulador-folha__hash">
          Resumo congelado · preview {{ conversa.acaoPendente.hashPreview | slice:0:12 }}… ·
          versão {{ conversa.versao }}
        </p>

        <p class="simulador-folha__travado" *ngIf="naoExecutarAcoes">
          <i class="fas fa-lock" aria-hidden="true"></i>
          A trava "não executar ações" está ligada. Desligue no cabeçalho para executar de verdade.
        </p>
      </div>

      <footer>
        <button class="simulador-folha__enviar" [disabled]="naoExecutarAcoes || conversa.operandoAcao"
                (click)="aprove()">
          {{ conversa.operandoAcao ? 'Executando…' : conversa.rotuloDaAprovacao }}
        </button>
      </footer>
    </div>
  </div>

  <!-- folha do rascunho: resumo por categoria, edição fica no painel -->
  <div class="simulador-folha" *ngIf="folhaRascunho">
    <div class="simulador-folha__fundo" (click)="folhaRascunho = false"></div>
    <div class="simulador-folha__painel">
      <header>
        <span>Rascunho v{{ conversa.analiseCardapio?.versao }}</span>
        <button (click)="folhaRascunho = false" title="Fechar">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="simulador-folha__corpo">
        <ul class="simulador-folha__categorias">
          <li *ngFor="let categoria of resumoPorCategoria">
            <span>{{ categoria.nome }}</span>
            <b>{{ categoria.itens }}</b>
            <em *ngIf="categoria.bloqueios">{{ categoria.bloqueios }} sem preço</em>
          </li>
        </ul>
        <p>
          No canal real, esta folha é a página aberta por link assinado. Aqui ela mostra o resumo:
          corrigir item a item continua no painel.
        </p>
      </div>

      <footer>
        <a class="simulador-folha__enviar" routerLink="/admin/mia-gestor">Abrir no painel</a>
      </footer>
    </div>
  </div>

  <!-- barra de envio -->
  <footer class="simulador__rodape">
    <input #seletorArquivos type="file" hidden multiple
           accept="application/pdf,image/jpeg,image/png,image/webp"
           (change)="selecioneArquivos($event)">
    <button class="simulador__pin" (click)="seletorArquivos.click()"
            [disabled]="!conversa.podeEnviarCardapio"
            title="Enviar o cardápio em PDF ou fotos, como o clipe do WhatsApp">
      <i class="fas fa-paperclip" aria-hidden="true"></i>
    </button>
    <input #campoMensagem type="text" [(ngModel)]="texto" (keydown)="aoTeclar($event)"
           placeholder="Digite como se fosse o lojista…"
           [disabled]="conversa.enviando || conversa.carregando || !conversa.onboardingId">
    <button class="simulador__enviar" (click)="envie()"
            [disabled]="!texto.trim() || conversa.enviando || conversa.carregando"
            title="Enviar (Enter)">
      <i class="fas fa-paper-plane" aria-hidden="true"></i>
    </button>
  </footer>
</div>

<app-estado-gestor></app-estado-gestor>
</div>
